import moment, { unitOfTime } from 'moment'
import { DatePeriodEnum } from '@/types/enums'

export class DatePeriod {
  private constructor (
    readonly number: number,
    readonly startDate: Date,
    readonly endDate: Date,
    readonly period: DatePeriodEnum
  ) {}

  get startDateString (): string {
    return this.startDate.toISOString()
  }

  get endDateString (): string {
    return this.endDate.toISOString()
  }

  public formattedStartDate (format: string): string {
    return moment(this.startDate).format(format)
  }

  public formattedEndDate (format: string): string {
    return moment(this.endDate).format(format)
  }

  public static createFromDateString (dateString: string, period: DatePeriodEnum): DatePeriod {
    let begin, end
    let periodCode: unitOfTime.StartOf = 'month'
    let periodFormat = 'MM'

    if (period === DatePeriodEnum.Week) {
      periodCode = 'isoWeek'
      periodFormat = 'w'
    }

    if (period === DatePeriodEnum.Day) {
      periodCode = 'day'
      periodFormat = 'DD'

      begin = moment(dateString).startOf(periodCode)
      end = moment(dateString).endOf(periodCode)
    } else {
      begin = moment(dateString).isoWeekday(1).startOf(periodCode)
      end = moment(dateString).isoWeekday(1).endOf(periodCode)
    }

    return new DatePeriod(
      parseInt(end.format(periodFormat)),
      begin.toDate(),
      end.toDate(),
      period
    )
  }

  public static createFromNow (period: DatePeriodEnum): DatePeriod {
    let periodCode: unitOfTime.StartOf = 'month'
    let periodFormat = 'MM'
    let begin, end

    if (period === DatePeriodEnum.Week) {
      periodCode = 'isoWeek'
      periodFormat = 'w'
    } else if (period === DatePeriodEnum.Day) {
      periodCode = 'day'
      periodFormat = 'DD'
    }

    if (period === DatePeriodEnum.Day) {
      begin = moment()
      end = moment()
    } else {
      begin = moment().isoWeekday(1).startOf(periodCode)
      end = moment().isoWeekday(1).endOf(periodCode)
    }

    return new DatePeriod(
      parseInt(end.format(periodFormat)),
      begin.toDate(),
      end.toDate(),
      period
    )
  }

  public static createFromTomorrow (period: DatePeriodEnum): DatePeriod {
    let periodCode: unitOfTime.StartOf = 'month'
    let periodFormat = 'MM'
    let begin, end

    if (period === DatePeriodEnum.Week) {
      periodCode = 'isoWeek'
      periodFormat = 'w'
    } else if (period === DatePeriodEnum.Day) {
      periodCode = 'day'
      periodFormat = 'DD'
    }

    if (period === DatePeriodEnum.Day) {
      begin = moment().add(1, 'd')
      end = moment().add(1, 'd')
    } else {
      begin = moment().add(1, 'd').isoWeekday(1).startOf(periodCode)
      end = moment().add(1, 'd').isoWeekday(1).endOf(periodCode)
    }

    return new DatePeriod(
      parseInt(end.format(periodFormat)),
      begin.toDate(),
      end.toDate(),
      period
    )
  }
}
